<script>
export default {
  props: {
    name: {
      type: String,
      default: 'Tab Item',
    },
  },
}
</script>

<template>
  <VTabItem>
    <slot />
  </VTabItem>
</template>
